/* import __COLOCATED_TEMPLATE__ from './address-input-field-admin1-old.hbs.js'; */
var _dec, _class;
import { tagName } from '@ember-decorators/component';
import AddressInputFieldAdmin1 from './address-input-field-admin1';
let AddressInputFieldAdmin1Old = (_dec = tagName(''), _dec(_class = class AddressInputFieldAdmin1Old extends AddressInputFieldAdmin1 {}) || _class);
export { AddressInputFieldAdmin1Old as default };